<template>
	<div>
	</div>
</template>
<script>
import { randomLenNum } from '@/util/util'
import { mapGetters } from 'vuex'
export default {
    computed: {
    ...mapGetters(['tagWel'])
    },
    created() {
        var access_token=sessionStorage.getItem('access_token')
        this.$store.commit('SET_ACCESS_TOKEN',access_token)
        this.$store.commit('ADD_TAG', this.tagWel)
        this.$router.push({ path: this.tagWel.value })
    },
    mounted() {}
}
</script>
<style lang="scss" scoped>
</style>
